import {
  aggregateFunctionResultType,
  ReportAggregateFunction,
  ReportEntityType
} from '@cumu/shared';
import { controller, target } from '@github/catalyst';
import { dispatchChange } from './util';

@controller('report-backed-subquery-parameter')
class ReportBackedSubqueryParameterElement extends HTMLElement {
  @target declare aggregateSelect: HTMLSelectElement;
  @target declare aggregationTargetFormGroup: HTMLElement;

  updateAggregation() {
    const remote =
      this.aggregationTargetFormGroup.querySelector('remote-input');
    const propertyInput =
      this.aggregationTargetFormGroup.querySelector<HTMLInputElement>(
        'input[name^="definition/"]'
      );
    if (!remote || !propertyInput) {
      return;
    }

    const url = new URL(remote.getAttribute('src')!, location.origin);
    const original_entity_type = url.searchParams.get('entity_type');
    const original_aggregate = url.searchParams.get('aggregate');
    const entity_type = this.sourceReportEntityType;

    const entity_type_changed = original_entity_type !== entity_type;
    const aggregate_result_changed =
      aggregateFunctionResultType[
        original_aggregate as ReportAggregateFunction
      ] !==
      aggregateFunctionResultType[
        this.aggregateSelect.value as ReportAggregateFunction
      ];

    if (entity_type_changed || aggregate_result_changed) {
      this.clearPropertyInput(propertyInput);
    }

    if (!entity_type || this.aggregateSelect.value === 'count') {
      this.aggregationTargetFormGroup.hidden = true;
      propertyInput.required = false;
    } else {
      this.aggregationTargetFormGroup.hidden = false;
      propertyInput.required = true;
    }

    if (entity_type) {
      this.updatePropertySuggestionSrc(entity_type);
    }
  }

  private get sourceReportEntityType(): ReportEntityType | null {
    const input = this.querySelector<HTMLInputElement>(
      'input[name$="/report_id:nullstring"]'
    );
    return (input?.dataset.reportEntityType as ReportEntityType) ?? null;
  }

  private clearPropertyInput(propertyInput: HTMLInputElement) {
    propertyInput.value = '';
    propertyInput.removeAttribute('value');
    propertyInput.removeAttribute('data-property');
    dispatchChange(propertyInput);
    propertyInput.previousElementSibling!.className =
      'color-fg-muted text-italic';
    propertyInput.previousElementSibling!.textContent = 'Select field...';
  }

  private updatePropertySuggestionSrc(entity_type: ReportEntityType) {
    const remote =
      this.aggregationTargetFormGroup.querySelector('remote-input')!;
    const url = new URL(remote.getAttribute('src')!, location.origin);
    url.searchParams.set('entity_type', entity_type);
    url.searchParams.set('association', entity_type);
    url.searchParams.set('aggregate', this.aggregateSelect.value);
    remote.setAttribute('src', `${url.pathname}?${url.searchParams}`);
    const remoteFilterInput = remote.firstElementChild as HTMLInputElement;
    remoteFilterInput.value = '';
    dispatchChange(remoteFilterInput);
  }
}

declare global {
  interface Window {
    ReportBackedSubqueryParameterElement: typeof ReportBackedSubqueryParameterElement;
  }
  interface HTMLElementTagNameMap {
    'report-backed-subquery-parameter': ReportBackedSubqueryParameterElement;
  }
}
